<template>
  <v-container fluid class="fill-height register-container">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="4">
        <!-- Logo -->
        <div class="text-center mb-4">
          <v-img :src="imageapp" height="180" contain class="mx-auto"></v-img>
          <v-label class="text-subtitle-1 text-grey">Visit · Verify · Monitor · One</v-label>
        </div>

        <!-- Card de Registro -->
        <v-card class="elevation-8 rounded-xl">
          <v-card-title class="text-h5 font-weight-bold text-center pa-6 bg-primary">
            <span class="text-white">Registro de Empresa</span>
          </v-card-title>

          <v-card-text class="pa-8">
            <!-- Alerta de éxito -->
            <v-alert
              v-if="successMessage"
              type="success"
              variant="tonal"
              class="mb-4"
              prominent
            >
              <div class="d-flex align-center">
                <v-icon size="large" class="mr-3">mdi-email-check</v-icon>
                <div>
                  <div class="text-h6 mb-2">{{ successMessage }}</div>
                  <div class="text-body-2">
                    Hemos enviado un correo de verificación a <strong>{{ formData.email_contacto }}</strong>
                  </div>
                  <div class="text-body-2 mt-2">
                    Por favor revisa tu bandeja de entrada y spam.
                  </div>
                </div>
              </div>
            </v-alert>

            <!-- Alerta de error -->
            <v-alert
              v-if="errorMessage"
              type="error"
              variant="tonal"
              class="mb-4"
              closable
              @click:close="errorMessage = ''"
            >
              {{ errorMessage }}
            </v-alert>

            <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
              <!-- Nombre de la Empresa -->
              <v-text-field
                v-model="formData.nombre"
                label="Nombre de la Empresa"
                prepend-inner-icon="mdi-domain"
                variant="outlined"
                :rules="[rules.required]"
                class="mb-2"
                color="primary"
              ></v-text-field>

              <!-- Nombre Comercial -->
              <v-text-field
                v-model="formData.nombre_comercial"
                label="Nombre Comercial"
                prepend-inner-icon="mdi-store"
                variant="outlined"
                :rules="[rules.required]"
                class="mb-2"
                color="primary"
              ></v-text-field>

              <!-- Nombre Contacto -->
              <v-text-field
                v-model="formData.contacto"
                label="Nombre de Contacto"
                prepend-inner-icon="mdi-account-box-outline"
                variant="outlined"
                :rules="[rules.required]"
                class="mb-2"
                color="primary"
              ></v-text-field>

              <!-- Telefono -->
              <v-text-field
                v-model="formData.telefono"
                label="Teléfono de Contacto"
                prepend-inner-icon="mdi-whatsapp"
                variant="outlined"
                :rules="[rules.required, rules.phone]"
                class="mb-2"
                color="primary"
              ></v-text-field>

              <!-- Email -->
              <v-text-field
                v-model="formData.email_contacto"
                label="Email de Contacto"
                prepend-inner-icon="mdi-email"
                variant="outlined"
                type="email"
                :rules="[rules.required, rules.email]"
                class="mb-2"
                color="primary"
              ></v-text-field>

              <!-- ✅ NUEVO: Confirmar Email -->
              <v-text-field
                v-model="formData.email_confirmation"
                label="Confirmar Email"
                prepend-inner-icon="mdi-email-check"
                variant="outlined"
                type="email"
                :rules="[rules.required, rules.email, rules.emailMatch]"
                class="mb-2"
                color="primary"
                hint="Ingresa nuevamente tu email para confirmar"
                persistent-hint
              ></v-text-field>

              <!-- Plan -->
              <v-select
                v-model="formData.plan"
                label="Plan"
                prepend-inner-icon="mdi-package-variant"
                variant="outlined"
                :items="plans"
                :rules="[rules.required]"
                class="mb-2"
                color="primary"
                readonly
                disabled
                hint="Todos comienzan con el Plan Gratuito. Puedes mejorar después del registro."
                persistent-hint
              ></v-select>

              <!-- Contraseña -->
              <v-text-field
                v-model="formData.emp_password"
                label="Contraseña"
                prepend-inner-icon="mdi-lock"
                variant="outlined"
                :type="showPassword ? 'text' : 'password'"
                :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append-inner="showPassword = !showPassword"
                :rules="[rules.required, rules.minLength]"
                class="mb-2"
                color="primary"
              ></v-text-field>

              <!-- Confirmar Contraseña -->
              <v-text-field
                v-model="formData.password_confirmation"
                label="Confirmar Contraseña"
                prepend-inner-icon="mdi-lock-check"
                variant="outlined"
                :type="showPasswordConfirm ? 'text' : 'password'"
                :append-inner-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append-inner="showPasswordConfirm = !showPasswordConfirm"
                :rules="[rules.required, rules.passwordMatch]"
                class="mb-4"
                color="primary"
              ></v-text-field>

              <!-- Botón de Registro -->
              <v-btn
                v-if="!successMessage"
                type="submit"
                block
                size="x-large"
                color="primary"
                class="text-none font-weight-bold mb-4"
                :loading="loading"
                :disabled="!valid || loading"
              >
                <v-icon left class="mr-2">mdi-check-circle</v-icon>
                Registrar Empresa
              </v-btn>

              <!-- Botón para ir al login después del registro -->
              <v-btn
                v-if="successMessage"
                block
                size="x-large"
                color="success"
                class="text-none font-weight-bold mb-4"
                @click="$router.push('/login')"
              >
                <v-icon left class="mr-2">mdi-login</v-icon>
                Ir al inicio de sesión
              </v-btn>

              <!-- Link a Login -->
              <div class="text-center">
                <span class="text-grey">¿Ya tienes una cuenta?</span>
                <router-link to="/login" class="text-primary font-weight-medium ml-1">
                  Iniciar sesión
                </router-link>
              </div>
            </v-form>
          </v-card-text>
          <div class="text-end mb-2 mr-6">
              <span class="text-grey" style="font-size: 14px;">Versión {{ app.version }}</span>
          </div>
        </v-card>

        <!-- Footer -->
        <div class="text-center mt-6 text-grey">
          <p class="text-caption">© 2025 VVM-One. Todos los derechos reservados.</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from '@/services/api'
import iconApp from '../assets/img/iconapp.png'
import { mapGetters } from 'vuex'
import { app } from '@/firebase/config';

export default {
  name: 'RegisterView',
  data() {
    return {
      imageapp: iconApp,
      valid: false,
      loading: false,
      showPassword: false,
      showPasswordConfirm: false,
      successMessage: '',
      errorMessage: '',
      formData: {
        nombre: '',
        nombre_comercial: '',
        contacto: '',
        telefono: '',
        email_contacto: '',
        email_confirmation: '',
        plan: 'FREE',
        emp_password: '',
        password_confirmation: '',
      },
      plans: [
        { title: 'Gratis - $0/mes', value: 'FREE' },
        { title: 'Profesional - $129/mes', value: 'PRO' },
        { title: 'Empresarial - Contactar', value: 'ENTERPRISE' },
      ],
      rules: {
        required: (value) => !!value || 'Este campo es requerido',
        email: (value) => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          return pattern.test(value) || 'Email inválido'
        },
        emailMatch: (value) => // ✅ NUEVO
        value === this.formData.email_contacto || 'Los emails no coinciden',
        phone: (value) => {
          const pattern = /^\d{10}$/
          return pattern.test(value) || 'Número de teléfono inválido'
        },
        minLength: (value) => value.length >= 8 || 'Mínimo 8 caracteres',
        passwordMatch: (value) =>
          value === this.formData.emp_password || 'Las contraseñas no coinciden',
      },
    }
  },
  computed: {
    ...mapGetters({app: 'app'}),
  },
  methods: {
    async handleSubmit() {
      // Validar formulario
      const { valid } = await this.$refs.form.validate()
      if (!valid) return

      this.loading = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        const response = await api.post('/register-company', this.formData)

        // Éxito
        this.successMessage = response.data.message || 'Empresa registrada correctamente. Por favor verifica tu correo electrónico.'
        
        // Limpiar formulario
        this.formData = {
          nombre: '',
          nombre_comercial: '',
          contacto: '',
          telefono: '',
          email_contacto: '',
          email_confirmation: '', // ✅ NUEVO
          plan: 'FREE',
          emp_password: '',
          password_confirmation: '',
        }
        
        // Resetear validación
        this.$refs.form.resetValidation()
        
      } catch (error) {
        // Manejo de errores
        if (error.response) {
          // Error del servidor
          if (error.response.data.errors) {
            // Errores de validación de Laravel
            const errors = Object.values(error.response.data.errors).flat()
            this.errorMessage = errors.join(', ')
          } else if (error.response.data.message) {
            this.errorMessage = error.response.data.message
          } else {
            this.errorMessage = 'Error al registrar la empresa. Intenta nuevamente.'
          }
        } else if (error.request) {
          // Error de red
          this.errorMessage = 'Error de conexión. Verifica tu conexión a internet.'
        } else {
          this.errorMessage = 'Error inesperado. Intenta nuevamente.'
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #dbeafe 100%);
}

.text-primary {
  color: #007BFF !important;
}

.text-grey {
  color: #6c757d;
}

.bg-primary {
  background: linear-gradient(135deg, #017CF8 0%, #0057D3 100%) !important;
}

.v-card {
  overflow: hidden;
}
</style>